import React from 'react';
import { InlineNotification } from '../inline-notification/component.js';
var NOTIFICATION_TYPES_MAP = {
  green: 'success',
  red: 'error',
  blue: 'info',
  yellow: 'warning'
};

var SystemNotification = function SystemNotification(_ref) {
  var content = _ref.content,
      id = _ref.id,
      level = _ref.level,
      onClose = _ref.onClose,
      title = _ref.title;

  var handleOnClose = function handleOnClose() {
    onClose(id);
  };

  var getNotificationType = function getNotificationType(type) {
    return NOTIFICATION_TYPES_MAP[type];
  };

  return /*#__PURE__*/React.createElement(InlineNotification, {
    type: level && getNotificationType(level),
    closeAction: handleOnClose
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "notification-title"
  }, title), ' ', content && /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: content
    },
    className: "notification-body",
    "aria-label": "notification-body"
  }));
};

SystemNotification.displayName = "SystemNotification";
export { SystemNotification };